import { createAction } from "redux-actions";
import { GET_OTHER_SERVICES } from "../constants";
import { feathersCreateData } from "../services";

export const getCollectionsOtherServices = createAction(GET_OTHER_SERVICES, () => feathersCreateData('core-server',{
    service : "SERVICES PAYMENTS", 
    func : "RETURN ALL AGREEMENTS"
})())